module.exports = __webpack_public_path__ + "img/ceder.0db1f2ce.png";